export const ROUTE_TO = 'ROUTE_TO';
export const TITLE_SERVICE = 'TITLE_SERVICE';
export const TITLE_SERVICE_NAME = 'TITLE_SERVICE_NAME';
export const TITLE_SERVICE_UF = 'TITLE_SERVICE_UF';

export default {
  namespaced: true,
  state: {
    toRoute: null,
    title: null,
    titleName: null,
    titleUf: null,
    titleDefault: 'Conteúdos Vivo',
  },
  getters: {
    route: state => state.toRoute,
    titleService: state => state.title,
  },
  mutations: {
    [ROUTE_TO](state, url) {
      state.toRoute = url;
    },
    [TITLE_SERVICE](state, title) {
      state.title = title;
    },
    [TITLE_SERVICE_NAME](state, name) {
      state.titleName = name;
    },
    [TITLE_SERVICE_UF](state, uf) {
      state.titleUf = uf;
    },
  },
  actions: {
    routeTo({ commit }, { fullPath }) {
      if (!fullPath.match(/\/login/g)) {
        const route = window.btoa(fullPath);
        commit(ROUTE_TO, route);
      }
    },
    async setTitle({ commit, rootGetters, state }, { title = null, system = 1 }) {
      let t = null;
      if (system === 1) {
        const uf = await rootGetters['user/uf'];
        t = title
            ? `${title} | ${state.titleDefault} | ${uf}`
            : uf
            ? `${state.titleDefault} | ${uf}`
            : `${state.titleDefault}`;
        window.document.title = t;
        commit(TITLE_SERVICE, t);
        commit(TITLE_SERVICE_NAME, title);
        commit(TITLE_SERVICE_UF, uf);
        return true
      } else {
        const uf = await rootGetters['vcUser/uf'];

        t = title && uf
            ? `${title} | ${uf}`
            : 'Vivo Consulta';

        window.document.title = t;
        commit(TITLE_SERVICE, t);
        commit(TITLE_SERVICE_NAME, title);
        commit(TITLE_SERVICE_UF, uf);
        return true
      }
    },
    setUF({ commit, state }, { uf }) {
      const title = state.titleName
        ? `${state.titleName} | ${state.titleDefault} | ${uf}`
        : `${state.titleDefault} | ${uf}`;
      window.document.title = title;
      commit(TITLE_SERVICE, title);
      commit(TITLE_SERVICE_UF, uf);
    },
  },
};
